import { ElementRef, Injectable } from '@angular/core';
import { SubHeaderDTO, ActionElementDTO, ActionGroupElementDTO, ActionInterface } from './sub-header.dtos';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { DomManipulationService } from '../../../_infrastructure/dom/dom-manipulation.service';

declare var jQuery: any;

@Injectable()
export class HeaderActionsService {

  private data: SubHeaderDTO;

  private taskHeaderClass = 'subHeaderTask';
  private dossierHeaderClass = 'subHeaderTaskDossier';
  private taskHeaderModalClass = 'subHeaderModalTask';
  private dossierHeaderModalClass = 'subHeaderModalTaskDossier';

  private observableData: Subject<SubHeaderDTO>;

  private isModal = false;


  private parentSavedHelpTags = new Map<string, Array<string>>();

  constructor(private _domService: DomManipulationService) {
    this.data = new SubHeaderDTO();
    this.observableData = new BehaviorSubject<SubHeaderDTO>(this.data);
  }

  public getConfig(): Observable<SubHeaderDTO> {
    return this.observableData;
  }


  public setParentSavedHelpTags(tags: Array<string>, windowHash: string) {
    this.parentSavedHelpTags.set(windowHash, tags);

  }

  public getParentSavedHelpTags(windowHash: string) {
    return this.parentSavedHelpTags.get(windowHash);
  }

  public setProject(
    elem: ElementRef,
    project: any,
    infoVisible: boolean,
    isModal?: boolean,
    showProjectInModal?: boolean,
    division?: any
  ) {
    this.data.project = project;
    this.data.division = division;
    this.data.infoVisible = infoVisible;
    this.data.showDocumentsVisible = false;
    this.data.showCalendarVisible = false;
    this.includeHeaderDiv(elem);
    this.isModal = isModal ? true : false;
    this.data.showProjectInModal = isModal && showProjectInModal;
    this.observableData.next(this.data);
  }

  public setShowDocumentsVisible(_showDocumentsVisible: boolean) {
    this.data.showDocumentsVisible = _showDocumentsVisible;
  }
  public setShowCalendarVisible(_showCalendarVisible: boolean) {
    this.data.showCalendarVisible = _showCalendarVisible;
  }

  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////

  public setTaskDescription2(
    containerSelector: string,
    taskDescription: string,
    taskIcon: string,
    visible: any,
    isModal?: boolean
  ) {
    this.isModal = isModal ? true : false;
    this.data.taskDescription = taskDescription;
    this.data.taskIcon = taskIcon;
    this.data.showDocumentsVisible = false;
    this.data.showCalendarVisible = false;
    if (typeof visible === 'boolean') {
      this.data.visible = function () {
        return visible;
      };
    } else {
      this.data.visible = visible;
    }
    const element = containerSelector;
    this.isModal ? this.includeHeaderDivModal2(element) : this.includeHeaderDiv2(element);
    this.observableData.next(this.data);
  }

  public includeHeaderDiv2(containerSelector: string): void {
    this._domService.prependHeader(containerSelector, 'dummy-header');
    this.updateBodyClasses(this.taskHeaderClass, this.dossierHeaderClass);
  }

  public includeHeaderDivModal2(containerSelector: string): void {
    this._domService.prependHeader(containerSelector, 'dummy-modal-header');
    this.updateBodyClasses(this.taskHeaderModalClass, this.dossierHeaderModalClass);
  }

  private updateBodyClasses(taskClass: string, dossierClass: string): void {
    this._domService.removeBodyClass(taskClass);
    this._domService.removeBodyClass(dossierClass);

    if (this.data.project && this.data.taskDescription) {
      this._domService.addBodyClass(dossierClass);
    } else if (this.data.taskDescription) {
      this._domService.addBodyClass(taskClass);
    }
  }
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////

  /**
  * @deprecated
  * MIGRATED TO: setTaskDescription2... delete after refactor.
  */
  public setTaskDescription(
    elem: ElementRef,
    taskDescription: string,
    taskIcon: string,
    visible: any,
    isModal?: boolean
  ) {
    this.isModal = isModal ? true : false;
    this.data.taskDescription = taskDescription;
    this.data.taskIcon = taskIcon;
    this.data.showDocumentsVisible = false;
    this.data.showCalendarVisible = false;
    if (typeof visible === 'boolean') {
      this.data.visible = function () {
        return visible;
      };
    } else {
      this.data.visible = visible;
    }
    if (this.isModal) {
      this.includeHeaderDivModal(elem);
    } else {
      this.includeHeaderDiv(elem);
    }
    this.observableData.next(this.data);
  }

  public setModalDescription(description: string) {
    this.data.modalDescription = description;
  }

  /**
  * @deprecated
  * MIGRATED TO: includeHeaderDiv2... delete after refactor.
  */
  private includeHeaderDiv(elem: ElementRef) {
    if (jQuery('dummy-header').length == 0) {
      jQuery(elem.nativeElement).prepend('<dummy-header></dummy-header>');
    }
    jQuery('body').removeClass(this.taskHeaderClass);
    jQuery('body').removeClass(this.dossierHeaderClass);
    if (this.data.project && this.data.taskDescription) {
      jQuery('body').addClass(this.dossierHeaderClass);
    } else if (this.data.taskDescription) {
      jQuery('body').addClass(this.taskHeaderClass);
    }
  }

  /**
  * @deprecated
  * MIGRATED TO: includeHeaderDiv2... delete after refactor.
  */
  private includeHeaderDivModal(elem: ElementRef) {
    if (jQuery('dummy-modal-header').length == 0) {
      jQuery(elem.nativeElement).prepend(
        '<dummy-modal-header></dummy-modal-header>'
      );
    }
    jQuery('body').removeClass(this.taskHeaderModalClass);
    jQuery('body').removeClass(this.dossierHeaderModalClass);

    if (this.data.project && this.data.taskDescription) {
      jQuery('body').addClass(this.dossierHeaderModalClass);
    } else if (this.data.taskDescription) {
      jQuery('body').addClass(this.taskHeaderModalClass);
    }
  }
  public addDivider() {
    let newAction: ActionElementDTO = this.createActionDivider();
    this.data.actions.push(newAction);
    this.observableData.next(this.data);
  }

  public addWindowDivider(windowHash: string) {
    if (windowHash) {
      let newAction: ActionElementDTO = this.createActionDivider();
      if (!this.data.windowactions.get(windowHash)) {
        this.data.windowactions.set(windowHash, []);
      }
      this.data.windowactions.get(windowHash).push(newAction);

      this.observableData.next(this.data);
    } else {
      this.addDivider();
    }
  }

  private createActionDivider() {
    let newAction: ActionElementDTO = new ActionElementDTO();
    newAction.type = 'divider';
    return newAction;
  }

  public addActionWithType(
    name: string,
    icon: string,
    classes: string,
    type: string,
    visible: any,
    enable?: any,
    disableTooltip?: string
  ): Observable<any> {
    let newAction = this.createAction(name, icon, classes, type, visible, enable, disableTooltip);
    this.data.actions.push(newAction);
    this.observableData.next(this.data);
    return this.createActionObservable(newAction);
  }

  public addAction(
    name: string,
    icon: string,
    classes: string,
    visible: any,
    enable?: any,
    disableTooltip?: string
  ): Observable<any> {
    return this.addActionWithType(name, icon, classes, 'button', visible, enable, disableTooltip);
  }
  public addWindowActionWithType(
    name: string,
    icon: string,
    classes: string,
    type: string,
    visible: any,
    hashId: string,
    enable?: any,
    disableTooltip?: string
  ): Observable<any> {
    let newAction: ActionElementDTO = this.createAction(name, icon, classes, type, visible, enable, disableTooltip);
    if (!this.data.windowactions.get(hashId)) {
      this.data.windowactions.set(hashId, []);
    }
    this.data.windowactions.get(hashId).push(newAction);

    this.observableData.next(this.data);
    return this.createActionObservable(newAction);
  }
  private createActionObservable(newAction: ActionElementDTO): Observable<boolean> {
    return new Observable(observer => {
      newAction.action = observer;
    });
  }

  private createAction(name: string, icon: string, classes: string, type: string, visible: any, enable: any, disableTooltip: string) {
    let newAction: ActionElementDTO = new ActionElementDTO();
    newAction.name = name;
    newAction.icon = icon;
    newAction.classes = classes;
    newAction.type = type;
    if (typeof visible === 'boolean') {
      newAction.visible = function () {
        return visible;
      };
    } else {
      newAction.visible = visible;
    }
    if (typeof enable === 'boolean') {
      newAction.enable = function () {
        return enable;
      };
    } else {
      newAction.enable = enable;
    }
    newAction.disableTooltip = disableTooltip;
    return newAction;
  }

  public addWindowAction(
    name: string,
    icon: string,
    classes: string,
    visible: any,
    hashId: string,
    enable?: any,
    disableTooltip?: string
  ): Observable<any> {
    if (hashId) {
      return this.addWindowActionWithType(
        name,
        icon,
        classes,
        'button',
        visible,
        hashId,
        enable,
        disableTooltip
      );
    } else {
      return this.addAction(name, icon, classes, visible, enable, disableTooltip);
    }
  }

  public clearActions() {
    this.clearActionList(this.data.actions);
    this.data.actions = [];
    this.observableData.next(this.data);
  }

  private clearActionList(actionList: Array<ActionInterface>): void {
    if (actionList) {
      for (let actionItem of actionList) {
        if (actionItem['actions']) {
          // es una agrupación de acciones
          actionItem.visible = undefined;
          actionItem.enable = undefined;
          this.clearActionList(actionItem['actions']);
          actionItem['actions'] = undefined;
        } else if (actionItem['action']) {
          actionItem['action'].unsubscribe();
          // limpiar referencias a funciones de componentes para prevenir perdida de memoria
          actionItem['action'] = undefined;
          actionItem.visible = undefined;
          actionItem.enable = undefined;
        }
      }
    }
  }
  // TODO revisar que la ayuda por windows hash no se está borrando
  public clearWindowActions(windowHash: string) {
    if (windowHash) {
      if (this.data.windowactions) {
        this.clearActionList(this.data.windowactions.get(windowHash));
        this.data.windowactions.delete(windowHash);
      }
      this.observableData.next(this.data);
    } else {
      this.clearActions();
    }
  }

  public clearSubHeader() {
    if (this.data.actions) {
      this.clearActionList(this.data.actions);
    }
    if (this.data.windowactions) {
      this.data.windowactions.clear();
    }
    this.data = null;
    this.observableData.next(this.data);
    this.data = new SubHeaderDTO();
    jQuery('dummy-header').remove();
    jQuery('body').removeClass(this.taskHeaderClass);
    jQuery('body').removeClass(this.dossierHeaderClass);

    jQuery('dummy-modal-header').remove();
    jQuery('body').removeClass(this.taskHeaderModalClass);
    jQuery('body').removeClass(this.dossierHeaderModalClass);
  }

  public addActionGroup(
    groupId: string,
    name: string,
    icon: string,
    classes: string,
    visible: any,
    hashId?: string,
    enable?: any,
    disableTooltip?: string
  ): void {
    let newAction: ActionGroupElementDTO = new ActionGroupElementDTO();
    newAction.id = groupId;
    newAction.name = name;
    newAction.icon = icon;
    newAction.classes = classes;
    if (typeof visible === 'boolean') {
      newAction.visible = function () {
        return visible;
      };
    } else {
      newAction.visible = visible;
    }
    if (typeof enable === 'boolean') {
      newAction.enable = function () {
        return enable;
      };
    } else {
      newAction.enable = enable;
    }

    let actionList: Array<ActionInterface>;
    if (hashId) {
      if (!this.data.windowactions.get(hashId)) {
        this.data.windowactions.set(hashId, []);
      }
      actionList = this.data.windowactions.get(hashId);
    } else {
      actionList = this.data.actions;
    }
    newAction.disableTooltip = disableTooltip;
    actionList.push(newAction);
  }


  public addActionToGroup(
    groupId: string,
    name: string,
    icon: string,
    classes: string,
    visible: any,
    hashId?: string,
    enable?: any,
    disableTooltip?: string
  ): Observable<any> {

    // buscar actionGroup
    let actionList: Array<ActionInterface>;
    if (hashId) {
      actionList = this.data.windowactions.get(hashId);
    } else {
      actionList = this.data.actions;
    }
    let group: ActionGroupElementDTO;
    if (actionList) {
      group = actionList.find(action => action['id'] === groupId) as ActionGroupElementDTO;
    }
    let newAction = this.createAction(name, icon, classes, undefined, visible, enable, disableTooltip);
    if (!group.actions) {
      group.actions = [];
    }
    group.actions.push(newAction);
    this.observableData.next(this.data);
    return this.createActionObservable(newAction);

  }



}
